<template>
  <div class="mobile-page">
    <div class="page-item">
      <div class="df both-side">
        <div class="df vertical" @click="backMenu">
          <img src="@/assets/img/mobile/page/menuPage.png" class="page-icon" />
          <div class="text">权限配置</div>
        </div>
        <!-- <div
          class="df vertical lease-action"
          @click="addOrEditSale(false, undefined)"
        >
          <img src="@/assets/img/mobile/lease/add-lease.png" />
          <div>新增售后人员</div>
        </div> -->
      </div>
    </div>

    <div class="content">
      <list-tree
        :treeData="tabledata"
        :treeLevel="0"
        @updateList="updateList"
      ></list-tree>
      <!-- <div v-for="item in tabledata" :key="item.id" class="after-sale-person">
        <div class="df person-info">
          <div class="job-title one-row">
            安视康医疗
          </div>
          <div class="user-name">{{ item.username }}</div>
        </div>
        <div class="df action">
          <div @click="addOrEditSale(true, item)">编辑</div>
          <div @click="doDelete(item)">删除</div>
          <div @click="setAuthority(item)">权限设置</div>
          <div
            @click="expand(item)"
            v-if="item.children && item.children.length > 0"
          >
             展开
          </div>
        </div>
      </div> -->
    </div>

    <!-- <footer>
      <pagination @pageChange="getQcUserList"></pagination>
    </footer> -->
  </div>

  <div class="modal" v-if="customModal.visiable" @click="handleCancel">
    <div class="modal-content">
      <div class="title" @click.stop="">{{ customModal.title }}</div>
      <div class="button">
        <div class="border-right" @click.stop="handleCancel">取消</div>
        <div @click.stop="handleCheck">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import { Toast } from "@/utils";
import { getUserList, deleteUser } from "@/request/view/repair";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { useStore } from "vuex";
import pagination from "@/views/mobile/components/pagination/index.vue";
import listTree from "@/views/mobileMenu/components/listTree/tree.vue";

export default defineComponent({
  components: { pagination, listTree },
  setup() {
    const tabledata = reactive([]);
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const saleListPayload = reactive({
      lineNum: 10,
      pageNum: 1,
      name: "",
      total: 0,
    });

    // 获取售后人员列表
    const getQcUserList = () => {
      getUserList({
        pageNum: store.state.mobilePage.pageNum,
        lineNum: store.state.mobilePage.lineNum,
        // name: saleListPayload.name,
        id: store.state.user.user.id,
      }).then((res) => {
        tabledata.length = 0;
        if (res.code === 200 && res.message === "成功") {
          // saleListPayload.total = res.data.total;
          // store.commit("SET_MOBILE_PAGE", { total: res.data.total });
          tabledata.push(...res.data);
        }
      });
    };

    // 模态框
    const customModal = reactive({
      visiable: false,
      title: "",
      id: "",
    });

    const handleCancel = () => {
      customModal.visiable = false;
      customModal.title = "";
    };

    const handleCheck = () => {
      deleteUser([customModal.id])
        .then((res) => {
          if (res.code === 200) {
            Toast("success", res.message, 3);
            getQcUserList();
          }
          handleCancel();
        })
        .catch((err) => {
          handleCancel();
        });
    };

    const addOrEditSale = (isEdit, data) => {
      router.push({
        path: "/mobilemenu/pageaction",
        query: {
          name: "salePerson",
          data: isEdit ? JSON.stringify(data) : undefined,
          type: isEdit ? "editSale" : "addSale",
        },
      });
    };

    const doDelete = (item) => {
      customModal.visiable = true;
      customModal.id = item.id;
      customModal.title = "确认删除？";
    };
    // 权限设置
    const setAuthority = (data) => {
      router.push({
        path: "/mobilemenu/pageaction",
        query: {
          name: "authority",
          data: JSON.stringify(data),
          type: "authority",
        },
      });
    };

    const backMenu = () => {
      router.back();
    };

    const expand = (record) => {
      const isExpand = record.expand === undefined ? false : record.expand;
      record.expand = !isExpand;
    };

    const updateList = () => {
      getQcUserList();
    };

    watch(
      () => router,
      () => {
        if (route.path === "/mobilemenu") {
          store.commit("SET_MOBILE_PAGE", {
            pageNum: 1,
            lineNum: 10,
            total: 0,
          });
          getQcUserList();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => route,
      (val) => {
        try {
          const { isEdit, update } = JSON.parse(
            localStorage.getItem("sale_update")
          );
          if (!isEdit) saleListPayload.pageNum = 1;
          if (update) getQcUserList();

          const useUpdate = {
            update: false,
            isEdit: false,
          };

          localStorage.setItem("sale_update", JSON.stringify(useUpdate));
        } catch (err) {}
      },
      {
        deep: true,
      }
    );

    return {
      expand,
      tabledata,
      backMenu,
      addOrEditSale,
      customModal,
      handleCancel,
      handleCheck,
      updateList,
      doDelete,
      setAuthority,
      getQcUserList,
    };
  },
});
</script>

<style lang="less" scoped>
@import url("../mobile/less/common.less");
.modal {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100vw;
  height: 100vh;
  .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 9.2rem;
    height: 3.43rem;
    background: #ffffff;
    box-shadow: 0rem 0.01rem 0.07rem 0rem rgba(38, 38, 38, 0.1);
    border-radius: 0.24rem;
    .title {
      height: 2.01rem;
      border-bottom: 1px solid #979797;
      font-size: 0.4rem;
      color: #11171e;
      line-height: 2.01rem;
      text-align: center;
    }
    .button {
      height: 1.39rem;
      display: flex;
      font-size: 0.4rem;
      color: #11171e;
      line-height: 1.39rem;
      text-align: center;
      .border-right {
        border-right: 1px solid #979797;
      }
    }
    .button > div {
      width: 50%;
    }
  }
}

.lease-action {
  img {
    width: 0.43rem;
    height: 0.43rem;
    display: block;
    margin-right: 0.11rem;
  }
  font-size: 0.48rem;
  font-weight: bold;
  color: #ffffff;
}

.mobile-page .page-item {
  height: 2.03rem;
}

.content {
  width: 100%;
  height: calc(100vh - 3.35rem);
  overflow: scroll;
  padding: 0 10px;
  .after-sale-person {
    background: url("../../assets/img/mobile/page/authority-background.png");
    width: 9.23rem;
    height: 2.61rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 0 auto 0.5rem;
    padding: 0.71rem 0.45rem 0.33rem;
    .person-info {
      .job-title {
        font-size: 0.43rem;
        font-weight: bold;
        color: #143022;
        margin-right: 0.84rem;
        width: 2.45rem;
      }
      .user-name {
        font-size: 0.37rem;
        font-weight: bold;
        color: #18412d;
      }
    }
    .action {
      margin-top: 0.5rem;
      font-size: 0.35rem;
      color: #179a90;
      div {
        margin-right: 0.85rem;
      }
    }
  }
}
</style>
